import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);
// router.js

const routes = [
  {
    path: '/', name: 'home', component: () => import('../views/home/home.vue'), meta: { title: 'hezone' },redirect:'homemain',
    children: [
      { path: 'homemain', name: 'homemain', component: () => import('../views/home/homemain.vue'), meta: { title: 'hezone' }, },
      { path: 'aboutus', name: 'aboutus', component: () => import('../views/aboutus'), meta: { title: 'hezone' }, },
      { path: 'news', name: 'news', component: () => import('../views/news'), meta: { title: 'hezone' }, },
      { path: 'contactus', name: 'contactus', component: () => import('../views/contactus'), meta: { title: 'hezone' }, },
      { path: 'product', name: 'product', component: () => import('../views/product'), meta: { title: 'hezone' }, },
      { path: 'productList', name: 'productList', component: () => import('../views/productList'), meta: { title: 'hezone' }, },
      { path: 'productAntiSilpStrip', name: 'productAntiSilpStrip', component: () => import('../views/product/productAntiSilpStrip'), meta: { title: 'hezone' }, },
      { path: 'productTactileIndicator', name: 'productTactileIndicator', component: () => import('../views/product/productTactileIndicator'), meta: { title: 'hezone' }, },
      { path: 'productStairNosing', name: 'productStairNosing', component: () => import('../views/product/productStairNosing'), meta: { title: 'hezone' }, },
      { path: 'productTactilePaving', name: 'productTactilePaving', component: () => import('../views/product/productTactilePaving'), meta: { title: 'hezone' }, },
      { path: 'productFRPProducts', name: 'productFRPProducts', component: () => import('../views/product/productFRPProducts'), meta: { title: 'hezone' }, },
      { path: 'productAccessories', name: 'productAccessories', component: () => import('../views/product/productAccessories'), meta: { title: 'hezone' }, },

    ]
  },//主页
];
const router = new VueRouter({

    routes: routes,
    
    // 指定该钩子函数，返回坐标值即可
    scrollBehavior () {

        return { x: 0, y: 0 }
    }
})
// const router = new VueRouter({
//   routes
// });

export default router;
